import React, { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import {
  $serviceLangList,
  serviceLangListMounted,
  syncOneLanguageMounted,
  syncOneLanguageStatus,
} from './model'
import { useUnit } from 'effector-react'
import { notification, Table } from 'antd'
import { getServiceList } from '../list/model'
import { ColumnsType } from 'antd/lib/table'
import { Service } from '../list/types'
import { ServiceStatus } from '../widgets/serviceStatus'
import { CButton } from '@coreui/react-pro'
import { path } from '../../../../libs'
import { useUrlFilters } from '../../../../libs/useUrlFilters'
import CIcon from '@coreui/icons-react'
import { cilSync, cilZoom } from '@coreui/icons'
import moment from 'moment'
import dayjs from 'dayjs'
import { NotificationPlacement } from 'antd/es/notification/interface'

export const DetailsService = () => {
  const navigate = useNavigate()

  const [api, contextHolder] = notification.useNotification()

  const { serviceName } = useParams()
  const [filteredList, setFilteredList] = useState<Service[]>([])

  const serviceLangList = useUnit($serviceLangList)
  const loading = useUnit(getServiceList.pending)

  const { filters, setFilter } = useUrlFilters({ lang: { type: 'array' } })

  const openSuccessNotification = (
    description: string,
    placement: NotificationPlacement,
  ) => {
    api.success({
      message: 'Sync language',
      description: description,
      placement,
    })
  }

  const openErrorNotification = (
    description: string,
    placement: NotificationPlacement,
  ) => {
    api.error({
      message: 'Error',
      description: description,
      placement,
    })
  }

  useEffect(() => {
    serviceLangListMounted()

    const unsubscribeSuccess = syncOneLanguageStatus.doneData.watch((data) =>
      openSuccessNotification(data.body.status, 'topRight'),
    )

    const unsubscribeError = syncOneLanguageStatus.failData.watch((data) =>
      openErrorNotification(data.body.message, 'topRight'),
    )

    return () => {
      unsubscribeSuccess()
      unsubscribeError()
    }
  }, [])

  useEffect(() => {
    setFilteredList(
      serviceLangList.filter((item) => item.service === serviceName),
    )
  }, [serviceLangList])

  const columns: ColumnsType<Service> = [
    {
      title: 'Language',
      dataIndex: 'lang',
      filters: filteredList.map((item) => ({
        text: item.lang,
        value: item.lang,
      })),
      filteredValue: filters.lang || null,
      onFilter: (value, record) => record.lang.indexOf(value as string) === 0,
    },
    {
      title: 'Updated At',
      dataIndex: 'updatedAt',
      render: (value: string) => dayjs(value).format('YYYY-MM-DD HH:mm'),
      sorter: (a, b) =>
        // @ts-ignore
        new Date(moment(a.createdAt, 'MMMM Do YYYY, h:mm:ss a').format('LLL')) -
        // @ts-ignore
        new Date(moment(b.createdAt, 'MMMM Do YYYY, h:mm:ss a').format('LLL')),
    },
    {
      title: 'Status',
      render: (item: Service) => {
        return <ServiceStatus service={item.service} langs={item.lang} />
      },
    },
    {
      title: 'Actions',
      fixed: 'right',
      width: 150,
      render: (item: Service) => {
        return (
          <>
            <CButton
              color="secondary"
              className="me-2"
              title="View"
              onClick={() =>
                navigate(
                  path.translations.services.edit(item.service, item.lang),
                )
              }
            >
              <CIcon icon={cilZoom} />
            </CButton>
          </>
        )
      },
    },
    {
      title: 'Sync language',
      fixed: 'right',
      width: 150,
      render: (item: Service) => {
        return (
          <>
            <CButton
              color="info"
              className="me-2"
              title="Sync language"
              onClick={() => {
                if (window.confirm('Are you sure?')) {
                  syncOneLanguageMounted({
                    service: item.service,
                    language: item.lang,
                  })
                }
              }}
            >
              <CIcon icon={cilSync} />
            </CButton>
          </>
        )
      },
    },
  ]

  return (
    <>
      {contextHolder}
      <Table
        dataSource={filteredList}
        bordered={true}
        scroll={{ x: true }}
        loading={loading}
        columns={columns}
        pagination={false}
        onChange={(_pagination, tableFilters) =>
          setFilter('lang', (tableFilters.lang as string[]) ?? undefined)
        }
      />
    </>
  )
}
